export function FlagFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4 3a1 1 0 011-1h4c1.264 0 2.233.641 2.942 1.11l.083.055C12.814 3.685 13.342 4 14 4c.745 0 1.81-.398 2.803-.894a17.872 17.872 0 001.527-.864l.09-.057.02-.014.005-.003A1 1 0 0120 3v9a1 1 0 01-.445.832L19 12l.555.832-.005.003-.008.005-.03.02-.108.07a19.81 19.81 0 01-1.707.965C16.69 14.397 15.255 15 14 15c-1.301 0-2.315-.645-3.062-1.121l-.055-.035C10.05 13.314 9.517 13 8.889 13H6v8a1 1 0 11-2 0V3z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
